/**
 * Thin wrappers so inputs/selects use Bootstrap form styles consistently.
 */
import { SearchableSelect } from './SearchableSelect.jsx';

/**
 * @param {import('react').FormHTMLAttributes<HTMLFormElement> & { className?: string }} props
 */
export function SearchForm({ className = '', ...props }) {
  return <form className={['search-form', className].filter(Boolean).join(' ')} {...props} />;
}

/**
 * @param {import('react').InputHTMLAttributes<HTMLInputElement> & { className?: string }} props
 */
export function FormInput({ className = '', ...props }) {
  return <input className={['form-control', className].filter(Boolean).join(' ')} {...props} />;
}

/**
 * @param {import('react').SelectHTMLAttributes<HTMLSelectElement> & { className?: string }} props
 */
export function FormSelect({ className = '', ...props }) {
  return <SearchableSelect className={['form-select', className].filter(Boolean).join(' ')} {...props} />;
}

/**
 * @param {import('react').TextareaHTMLAttributes<HTMLTextAreaElement> & { className?: string }} props
 */
export function FormTextarea({ className = '', ...props }) {
  return <textarea className={['form-control', className].filter(Boolean).join(' ')} {...props} />;
}
